import { GabbyUserModel } from './gabby-user.model';

export class GabbyUserSearchModel extends GabbyUserModel {}
